




















import Vue from "vue";

export default Vue.extend({
  name: "vc-image-modal",
  data: function() {
    return {
      showContent: false
    };
  },
  props: {
    dataSrc: {
      type: String,
      default: ""
    },
    addClass: {
      type: String,
      default: ""
    }
  },
  methods: {
    openModal() {
      this.showContent = true;
    },
    closeModal() {
      this.showContent = false;
    }
  }
});
